<template>
  <div v-if="show" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-content" @click.stop>
      <h2 class="modal-title">Cancel Subscription</h2>
      <p class="modal-message">
        Are you sure you want to cancel your subscription? You will stil have access to premium features until <b>{{ formattedNextPayment }}</b>.
      </p>

      <div class="modal-actions">
        <button class="cancel-btn" @click="handleCancel">Keep Subscription</button>
        <button class="confirm-btn" @click="handleConfirm">Cancel Subscription</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancelSubscriptionModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    nextPaymentAt: {
      type: String,
      required: false
    }
  },
  computed: {
    formattedNextPayment() {
      if (!this.nextPaymentAt) return '';
      const date = new Date(this.nextPaymentAt);
      if (isNaN(date)) return this.nextPaymentAt;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleOverlayClick() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.modal-message {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}


.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid #ccc;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #f5f5f5;
}

.confirm-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  background: #d32f2f;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn:hover {
  background: #b71c1c;
}
</style> 